import { render, staticRenderFns } from "./viewStudentQuestionnaireAnswer.vue?vue&type=template&id=778a7fa0&scoped=true"
import script from "./viewStudentQuestionnaireAnswer.vue?vue&type=script&lang=js"
export * from "./viewStudentQuestionnaireAnswer.vue?vue&type=script&lang=js"
import style0 from "./viewStudentQuestionnaireAnswer.vue?vue&type=style&index=0&id=778a7fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a7fa0",
  null
  
)

export default component.exports